import {CheckCircleFilled, CopyOutlined} from '@ant-design/icons';
import styles from './viewOrders.module.scss';
import {useState} from 'react';
import {ModalShell} from './ui/ModalShell';

export const ViewBrokerOrderIds = ({data}) => {
  const [copiedId, setCopiedId] = useState(null);

  const handleCopy = text => {
    navigator.clipboard.writeText(text);
    setCopiedId(text);
    setTimeout(() => {
      setCopiedId(null);
    }, 1000);
  };

  return (
    <ModalShell
      title="Broker order IDs"
      subtitle={
        data?.brokerIds?.length
          ? `${data.brokerIds.length} broker order${
              data.brokerIds.length === 1 ? '' : 's'
            } stand behind this order.`
          : 'This order was not routed to a broker, so it carries no broker IDs.'
      }>
      <div className={styles.orderIds}>
        {data?.brokerIds?.map(order => (
          <div key={order} className={styles.orderIdContainer}>
            <p>{order}</p>
            <div className={styles.copyWrapper}>
              {copiedId === order ? (
                <CheckCircleFilled className={styles.copyIcon} />
              ) : (
                <CopyOutlined
                  onClick={() => handleCopy(order)}
                  title="Copy to clipboard"
                />
              )}
            </div>
          </div>
        ))}
      </div>
    </ModalShell>
  );
};
